import * as appStore from '../store/app';

class CastReceiver {
  constructor(ctrl, config) {
    this.ctrl = ctrl;
    this.store = this.ctrl.store;
    this.session = this.ctrl.session;
    this.namespace = config.namespace;
    this.castState = null;
    this.senderId = config.senderId;
  }
  startSession(data) {
    this.ctrl.appConfig = {
      ...this.ctrl.appConfig,
      ...data.config,
    };
    this.store.dispatch(appStore.setAppConfig(this.ctrl.appConfig));
    this.session.startMain();
  }
  onSenderMessages(customEvent) {
    if (customEvent.data && customEvent.data.action) {
      const senderId = customEvent.senderId;
      if (!this.senderId) {
        this.senderId = senderId;
      }
      const data = customEvent.data;
      switch (data.action) {
        case 'SET_VOLUME':
          this.store.dispatch(appStore.setVideoVolume(data.volume));
          break;
        default:
          break;
      }
    }
  }
  sendMessage(data) {
    if (this.senderId) {
      window.cast.framework.CastReceiverContext.getInstance().sendCustomMessage(this.namespace, this.senderId, {
        ...data,
      });
    }
  }
}

export default CastReceiver;
